import { Box } from "@mui/material";

import { COLORS } from "../../../constants/colors";

const LightenDarkenColor = (col: string, amt: number): string => {
  let usePound = false;
  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  } else if (col[0] === "r") {
    return "#dadada";
  }

  const num = parseInt(col, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
};

/* styleguidist requires component to have props, idk why */
// eslint-disable-next-line
const Colors = (_props: {}): JSX.Element => (
  <Box display="flex" flexWrap="wrap">
    {Object.keys(COLORS).map((itm) => (
      <Box
        key={itm}
        display="flex"
        justifyContent="center"
        alignItems="center"
        m={4}
      >
        <Box
          width={48}
          height={48}
          style={{
            backgroundColor: COLORS[itm],
            border: `2px solid ${LightenDarkenColor(COLORS[itm], -50)}`,
          }}
        />
        <Box ml={6} sx={{ minWidth: "150px" }}>
          <Box sx={{ textTransform: "lowercase" }}>#{itm}</Box>
          <Box fontSize="small" sx={{ color: COLORS.SATURATED_GREY }}>
            {COLORS[itm]}
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
);

export default Colors;
